import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import "./view.css";
import apsandlogo from "../assets/apsandlogo.png";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const ViewQRData = () => {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("loading");
  
  useEffect(() => {
    const id = searchParams.get("id");
  
    if (!id) {
      setStatus("no");
      return;
    }
  
    const fetchData = async () => {
      try {
        const docRef = doc(db, "deliveries", id);
        const docSnap = await getDoc(docRef);
  
        if (docSnap.exists()) {
          setData(docSnap.data());
          setStatus("ok");
        } else {
          setStatus("no");
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setStatus("invalid");
      }
    };
  
    fetchData();
  }, []);
  

  if (status === "loading") return null;
  if (status === "no") return <div className="error">❌ No QR data found</div>;
  if (status === "invalid")
    return <div className="error">❌ QR data is invalid or corrupted</div>;

  return (
    <div className="wrappers">
      {/* HEADER */}
      <div className="header-bar">
        <img src={apsandlogo} alt="AP Logo" className="header-logo" />

        <div className="header-text">
          <div className="title-main">AP SAND MANAGEMENT SYSTEM</div>
          <div className="title-sub">Department of Mines & Geology</div>
          <div className="title-sub2">Government of Andhra Pradesh</div>
        </div>
      </div>

      {/* BLACK TITLE BAR */}
      <div className="banner">
        Free Sand Information
        <br />
        Details
      </div>

      {/* ORANGE SECTION TITLE */}
      <div className="section-header">
    {/* <span className="section-icon">🛒</span> */}
    <svg
  xmlns="http://www.w3.org/2000/svg"
  width="22"
  height="22"
  viewBox="0 0 24 24"
  fill="white"
  stroke="white"
  strokeWidth="1.8"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <circle cx="9" cy="21" r="1" />
  <circle cx="20" cy="21" r="1" />
  <path d="M1 1h4l2.68 12.39A2 2 0 0 0 9.62 15h9.76a2 2 0 0 0 1.94-1.61L23 6H6" />
</svg>

    <span>General CONSUMER</span>
  </div>
      <div className="info-card">
        <div className="row">
          <span className="label">Registration ID</span>
          <div className="colon">:</div>

          <span className="value">{data.registrationId}</span>
        </div>

        <div className="row">
          <span className="label">Consumer Name</span>
          <div className="colon">:</div>

          <span className="value">{data.customername}</span>
        </div>

        <div className="row">
          <span className="label">Consumer Mobile</span>
          <div className="colon">:</div>

          <span className="value">{data.customermobile}</span>
        </div>

        <div className="row">
          <span className="label">Construction Name</span>
          <div className="colon">:</div>

          <span className="value">{data.constructionName}</span>
        </div>

        <div className="row">
          <span className="label">Registration Date</span>
          <div className="colon">:</div>

          <span className="value">{data.registrationDate}</span>
        </div>

        <div className="row">
          <span className="label">Registration Type</span>
          <div className="colon">:</div>

          <span className="value">{data.registrationType}</span>
        </div>

        <div className="row">
          <span className="label">Registration QTY(in MT)</span>
          <div className="colon">:</div>

          <span className="value">{data.registrationQty} MT</span>
        </div>

        <div className="row">
          <span className="reg-label">Registration Address</span>
          <div className="colon">:</div>

          <span className="reg-value">{data.address}</span>
        </div>

        <hr />

        <div className="row">
          <span className="label">Available Sand Qty(in MT)</span>
          <div className="colon">:</div>

          <span className="value">{data.availableSandQty}</span>
        </div>

        <div className="row">
          <span className="label">Eligible Sand Qty(in MT)</span>
          <div className="colon">:</div>

          <span className="value">{data.eligibleSandQty}</span>
        </div>

        <hr />

        <div className="row">
          <span className="label">Dispatch ID</span>
          <div className="colon">:</div>

          <span className="value">{data.dispatchId}</span>
        </div>

        <div className="row">
          <span className="label">Trip Number</span>
          <div className="colon">:</div>

          <span className="value">{data.tripno}</span>
        </div>

        <div className="row">
          <span className="label">Vehicle Number/Type</span>
          <div className="colon">:</div>

          <span className="value">{data.vehicleno}</span>
        </div>

        <div className="row">
          <span className="label">Driver Name/Mobile No</span>
          <div className="colon">:</div>

          <span className="value">
            {data.drivername}, {data.drivermobile}
          </span>
        </div>

        <div className="row">
          <span className="label">Dispatch Quantity(in MT)</span>
          <div className="colon">:</div>

          <span className="value">{data.sandquantity} Tons</span>
        </div>

        <div className="row">
          <span className="label">Dispatch Date Time</span>
          <div className="colon">:</div>

          <span className="value">{data.dispatchdate} {data.dispatchTime}</span>
        </div>

        <div className="row">
          <span className="reg-label">Dispatch Address</span>
          <div className="colon">:</div>
          <span className="reg-value">{data.address}</span>
        </div>
      </div>

      <div className="footer">
        Copyright © 2024 AP Sand Management Monitoring System.
        <br />
        All Rights Reserved
      </div>
    </div>
  );
};

export default ViewQRData;
